'use client';

import Link from 'next/link';
import PropTypes from 'prop-types';

// Free postal entry route. The Gambling Act 2005 exemption for prize
// competitions relies on the free route being genuinely available, so it is
// stated plainly on every competition and links to the full instructions.
const FreeEntryNotice = () => {
  return (
    <p className="text-sm leading-[1.55] text-muted-foreground max-w-[68ch]">
      <span className="font-medium text-foreground">Free entry by post:</span> you can enter this
      competition free by sending a postcard or letter. Postal entries go into the same draw as paid
      entries.{' '}
      <Link href="/free-entry" className="font-semibold text-accent-bright underline underline-offset-2 hover:text-foreground">
        How to enter by post
      </Link>{' '}
      (see also{' '}
      <Link
        href="/terms-and-conditions#clause-5-12"
        className="font-semibold text-accent-bright underline underline-offset-2 hover:text-foreground"
      >
        terms 5.12 to 5.20
      </Link>
      ).
    </p>
  );
};

FreeEntryNotice.propTypes = {
  competition: PropTypes?.shape({
    title: PropTypes?.string,
  }),
};

export default FreeEntryNotice;
